<template>
  <v-ons-page>
    <v-ons-toolbar>
      <div class="center">楽曲リスト</div>
    </v-ons-toolbar>
    <v-ons-list id="music-list">
      <v-ons-list-item class="music-list-item" v-for="music in musics">
        <div @click="applyBpm(music)">
          <div class="title-advice">
            <div class="inner">
              <span class="title">{{music.title}}</span><br>
              <span class="advice list-item__subtitle">{{music.advice}}</span>
            </div>
          </div>
          <div class="bpm"><div class="inner">BPM<br>{{music.bpm_before}} → {{music.bpm_after}}</div></div>
        </div>
        <v-ons-icon
          class="icon-info right"
          icon="md-info-outline"
          size="24px, material:24px"
          @click="pushMusicDetailPage(music)">
        </v-ons-icon>
      </v-ons-list-item>
    </v-ons-list>
  </v-ons-page>
</template>

<script>
  import Papa from 'papaparse'
  import MusicDetailPage from './MusicDetailPage'

  export default {
    name: 'music-list-page',
    data () {
      return {
        musics: [
        ]
      }
    },
    methods: {
      updateMusicList: function () {
        let xhr = new XMLHttpRequest()
        let url = require('../assets/musics.csv')
        let methods = this
        // ハンドラの登録
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200 || xhr.status === 304) {
              let csvString = xhr.responseText
              methods.applyMusicListCsv(csvString)
            }
          }
        }
        xhr.open('GET', url, true)
        xhr.send()
      },
      applyMusicListCsv: function (csvString) {
        this.musics = Papa.parse(csvString, {header: true}).data
        this.musics.pop()
      },
      applyBpm: function (music) {
        document.dispatchEvent(new CustomEvent('applyBpm', {detail: music}))
      },
      pushMusicDetailPage: function (music) {
        this.$emit('push-page', {
          extends: MusicDetailPage,
          onsNavigatorProps: {
            music: music
          }
        })
      }
    },
    created: function () {
      this.updateMusicList()
    }
  }
</script>

<style scoped>
  .music-list-item, .music-list-item >.list-item__center > div {
    display: flex;
    text-align: center;
    width: 100%;
  }

  .music-list-item .title-advice {
    width: 65%;
    height: 100%;
    display: table;
    margin: auto;
  }

  .music-list-item .bpm {
    width: 35%;
    height: 100%;
    display: table;
    margin: auto;
  }

  .inner {
    display: table-cell;
    vertical-align: middle;
  }

  .icon-info {
    padding: 12px;
    padding-right: 20px;
  }

  .ios .icon-info {
    color: #4783FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/MusicListPage.vue